import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Permission from '../../functions/permission';
import Loading from '../loading';
import Add from './add';

class CustomerType extends React.Component {

  state = {
    customerTypes: [], menuPermission:[]
  }

  componentDidMount() {
    this.getPermission();
  }

  getPermission() {
    let menuPermission = Permission('customer-type', this.props.menus);
    if (menuPermission.view) {
      this.getCustomerType();
    }
    this.setState({ menuPermission })
  }

  getCustomerType() {
      
      let context = this;
      $.ajax({
        type: 'POST',
        url: Server() + 'customertype/get.php',
        success: function(customerTypes) {
          try {
            customerTypes = JSON.parse(customerTypes);
            context.setState({ customerTypes })
          } catch (error) {
            alert('Try Again!!!');
          }
        },
        error: function(e) {
          context.setState({ load: false });
        }
      });
  }

  render() {
      let sino = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Title title={'Customer Type'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          <div style={{margin: '5px'}}>
            { this.state.menuPermission.add ?
              <Add getCustomerType={this.getCustomerType.bind(this)} />:''
            }
            <table id="table" width="100%">
                <tr id="th">
                    <th>Sino</th>
                    <th>Customer Type</th>
                    <th>Created by</th>
                    <th>Status</th>
                    { 
                      this.state.menuPermission.edit ?
                      <th>Action</th>:''
                    }
                </tr>
                {
                    this.state.customerTypes.map((c) => {
                        return (
                            <tr>
                                <td>{sino++}</td>
                                <td>{c.type_name}</td>
                                <td>{c.createdby}</td>
                                <td>{c.status}</td>
                                { 
                                  this.state.menuPermission.edit ?
                                  <td>
                                      <center>
                                          <Add type="edit" getCustomerType={this.getCustomerType.bind(this)} item={c} />
                                      </center>
                                  </td>:''
                                }
                            </tr>
                        )
                    })
                }
            </table>
          </div>:
          <center>You Are Not Allow To Access This Menu!!!</center>
        }
      </div>
    );
  }
}

export default CustomerType;
